import { render } from "./replyPanel.vue?vue&type=template&id=34c8224e&scoped=true"
import script from "./replyPanel.vue?vue&type=script&lang=js"
export * from "./replyPanel.vue?vue&type=script&lang=js"

import "./replyPanel.vue?vue&type=style&index=0&id=34c8224e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c8224e"]])

export default __exports__